import { render, staticRenderFns } from "./LinkIntegracao.vue?vue&type=template&id=2c834aaf&scoped=true"
import script from "./LinkIntegracao.vue?vue&type=script&lang=js"
export * from "./LinkIntegracao.vue?vue&type=script&lang=js"
import style0 from "./LinkIntegracao.vue?vue&type=style&index=0&id=2c834aaf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c834aaf",
  null
  
)

export default component.exports